import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["form", "checkbox"]
  static values = { confirmLabel: String }

  onChange() {
    const checkbox = this.checkboxTarget
    const form = this.formTarget

    if (!this.confirmLabelValue) {
      form.requestSubmit()
      return
    }

    // Ask confirmation BEFORE submitting
    // eslint-disable-next-line no-alert
    const confirmed = window.confirm(this.confirmLabelValue)

    if (!confirmed) {
      // Revert the visual toggle immediately
      checkbox.checked = !checkbox.checked
      return
    }

    form.requestSubmit()
  }
}
